import { render, staticRenderFns } from "./LogoOnFacadeSection.vue?vue&type=template&id=4c797016"
import script from "./LogoOnFacadeSection.vue?vue&type=script&lang=ts"
export * from "./LogoOnFacadeSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoOnFacadeSection.vue?vue&type=style&index=0&id=4c797016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports